import React, { useEffect, useRef } from "react";
import lottie from "lottie-web/build/player/lottie_light.js";
import style from "./AnimationSlide.module.css";
import IconList from "../../Features/IconList/IconList";

function AnimationSlide({ slide, currentSlide, totalSlides }) {
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Очищаем контейнер
    containerRef.current.innerHTML = "";

    if (slide.media.animationData) {
      // Если есть animationData, значит это Lottie-анимация
      animationRef.current = lottie.loadAnimation({
        container: containerRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: slide.media.animationData,
      });
    } else if (slide.media.src) {
      // Если есть src, значит это обычное изображение
      const img = document.createElement("img");
      img.src = slide.media.src;
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.objectFit = "contain";
      containerRef.current.appendChild(img);
    }

    return () => {
      if (animationRef.current) {
        animationRef.current.destroy();
      }
    };
  }, [slide]);

  return (
    <div className={style.animationSlideContainer}>
      <div
        ref={containerRef}
        className={style.animationContainer}
        style={{ width: slide.media.size, height: slide.media.size }}
      />
      <div className={style.textContainer}>
        <div className={style.pagination}>
          {currentSlide + 1} / {totalSlides}
        </div>
        <h1 dangerouslySetInnerHTML={{ __html: slide.title }}></h1>
        <p dangerouslySetInnerHTML={{ __html: slide.description }}></p>
        {slide.list && <IconList list={slide.list} />}
      </div>
    </div>
  );
}

export default AnimationSlide;
